import React from "react";
import { ImageOverlay } from "../elements/headerComponents";
import { Section } from "../elements/bodyComponents";

//styles
import "../css/legal.css";

import { ShowPage, HidePage } from "../helpers/helpers";

/*
    Privacy Policy
*/
export class PrivacyPolicy extends React.Component {
  componentDidMount() {
    document.querySelector(".globalNav").setAttribute("data-activepage", "");
    document.getElementById("pageContent").style.opacity = 1;

    ShowPage();
  }

  componentWillUnmount() {
    HidePage();
  }

  render() {
    return (
      <div
        id="privacyPolicy"
        className="layout-privacy layout-home usingMasterCard"
      >
        <header className="pageHeader">
          <ImageOverlay classes="introOverlay text-align-center">
            <h1 className="headline uppercase color-gray">
              Privacy Notice for the Food Network Kitchen™ inspirations website
            </h1>
          </ImageOverlay>
          <div className="header-background" />
        </header>

        <Section classes="privacyContent masterCard padding-y-xlarge padding-x-xlarge">
          <p className="text-align-center">
            <b>
              Privacy NOTICE for the Food Network Kitchen™ inspirations website
            </b>
          </p>

          <p className="text-align-center tiny">
            <i>
              operated by Television Food Network, g.p. for Kraft Foods Group,
              inc.
            </i>
          </p>

          <p>
            Thank you for visiting The Food Network Kitchen Inspirations™
            website (<a href="http://foodnetworkkitcheninspirations.com/">
              http://foodnetworkkitcheninspirations.com/) ("Site") operated by
              Television Food Network, G.P.
            </a>{" "}
            ("TVFN"," "we," "our," or "us") on behalf of The Kraft Heinz Company
            ("Kraft Heinz") in connection with TVFN's "Food Network Kitchen
            Inspirations" partnership with Kraft Heinz. We provide this notice
            to explain our information practices and the choices you can make
            about the collection and use of information collected through this
            Site.
          </p>

          <p>This privacy notice ("Privacy Notice") explains:</p>

          <ol>
            <li>Scope And Consent</li>
            <li>Information We Collect</li>
            <li>Uses and Retention</li>
            <li>Disclosure</li>
            <li>Your Choices</li>
            <li>Notice to California Residents</li>
            <li>Third Parties</li>
            <li>Security</li>
            <li>Children's Privacy</li>
            <li>Notification Regard Updates</li>
            <li>How to Contact Us</li>
          </ol>

          <div class="rules-section">
            <h4>1. Scope And Consent</h4>
            <p>
              When you visit this Site, you are contracting with TVFN which is
              operating the Site on behalf of Kraft Heinz. By using the Site,
              you expressly consent to TVFN's collection, use, disclosure, and
              retention of your information as described in this Privacy Notice.
              Your use of the Site also constitutes your agreement to arbitrate
              any claims associated with your use of this Site, with no class
              relief.
            </p>
          </div>

          <div class="rules-section">
            <h4>2. Information We Collect</h4>
            <p>
              We collect usage information sent to us by your device (e.g.,
              laptop, tablet or mobile) that tells us how you are using the
              Site. We may use tracking technologies (e.g., cookies, web
              beacons/GIFs, pixels, page tags, and embedded scripts) for a
              variety of purposes, including to tell us how many times you have
              used the Site and what content you are viewing on the Site.
            </p>
            <p>
              We strive to collect and use only that information that is
              required for our legitimate business interests, including
              improving your experience with the Site and providing marketing.
            </p>
          </div>

          <div class="rules-section">
            <h4>3. Uses and Retention</h4>
            <p>
              We use your information to perform data analysis and for marketing
              purposes. We retain information as long as it is necessary and
              relevant for our operations. By using the Site, you agree that
              TVFN may collect and share your behavioral data using tracking
              technologies.
            </p>
          </div>

          <div class="rules-section">
            <h4>4. Disclosure</h4>
            <p>
              <b>
                <i>Business Partners:</i>
              </b>{" "}
              We may share the information we collect about you with business
              partners such as Kraft Heinz, on whose behalf we are operating
              this Site.
            </p>
            <p>
              <b>
                <i>Affiliates:</i>
              </b>{" "}
              We may share the information we collect about you with TVFN's
              subsidiaries and other affiliated entities.
            </p>
            <p>
              <b>
                <i>Service Providers:</i>
              </b>{" "}
              We may disclose your information to third parties who perform
              services for us (e.g., third-party analytic or marketing online
              services). These third parties are not authorized by us to use or
              disclose the information except as necessary to perform services
              for us or comply with legal requirements.
            </p>
            <p>
              <b>
                <i>Legal and Law Enforcement:</i>
              </b>{" "}
              We also may disclose information about you (i) if we are required
              by law (ii) in response to requests by government agencies, or
              (iii) when we believe disclosure is appropriate to prevent
              physical harm, financial loss, or to conduct an investigation of
              suspected or actual illegal activity.
            </p>
            <p>
              <b>
                <i>Change of Control:</i>
              </b>{" "}
              We reserve the right to transfer any information we have about you
              in the event we sell or transfer all or a portion of our business
              or assets (including in the event of a reorganization, dissolution
              or liquidation).
            </p>
          </div>

          <div class="rules-section">
            <h4>5. Your Choices</h4>
            <p>
              Most web browsers automatically accept cookies but, if you prefer,
              you can usually modify your browser setting to disable or reject
              cookies. If you delete your cookies or if you set your browser to
              decline cookies, some features of the Services may not work or may
              not work as designed.
            </p>
            <p>
              You can opt-out of certain tracking by visiting{" "}
              <a
                href="https://www.evidon.com/resources/global-opt-out/"
                target="_blank"
              >
                https://www.evidon.com/resources/global-opt-out/
              </a>
            </p>
          </div>

          <div class="rules-section">
            <h4>6. Notice to California Residents</h4>
            <p>
              California Business & Professions Code Section 22575(b) provides
              that California residents are entitled to know how TVFN responds
              to "Do Not Track" browser settings. Your browser or device may
              include "Do Not Track" functionality. How browsers communicate the
              Do Not Track signal is not yet uniform, so a standard
              technological response has not yet been developed by the policy
              and technological communities. For this reason, we do not respond
              to Do Not Track signals currently, and we await the result of work
              by the policy community and industry to determine when such a
              response is appropriate and what form it should take. Our
              information collection and disclosure practices, and the choices
              that we provide, will continue to operate as described in this
              Notice and in our Privacy Policy, whether or not a Do Not Track
              signal is received.
            </p>
          </div>

          <div class="rules-section">
            <h4>7. Third Parties</h4>
            <p>
              Our Site may contain links to third-party websites and apps that
              are unaffiliated with TVFN. We are not responsible for the privacy
              practices of third parties.
            </p>
          </div>

          <div class="rules-section">
            <h4>8. Security</h4>
            <p>
              We require our service providers for this Site to maintain
              technical, physical, and administrative security measures to
              protect the security of your personal or behavioral information
              against loss, misuse, unauthorized access, disclosure, or
              alteration.
            </p>
          </div>

          <div class="rules-section">
            <h4>9. Children's Privacy</h4>
            <p>
              The Site is not intended for children under the age of 13. We do
              not knowingly collect personal information from users under the
              age of 13.
            </p>
          </div>

          <div class="rules-section">
            <h4>10. Notification Regard Updates</h4>
            <p>
              You agree that we may notify you about material changes in the way
              we treat your personal information by placing a notice in the
              Site. Check the Site frequently for updates.
            </p>
          </div>

          <div class="rules-section">
            <h4>11. How to Contact Us</h4>
            <p>You may contact us at privacy@scrippsnetworks.com.</p>
          </div>
        </Section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/privacyPolicy.js